import * as React from 'react';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { getCardItems, getCardPlaceholders } from 'helpers/common';
import { default as Slider } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { InfiniteScrollIntersection } from 'components/Common/InfiniteScrollIntersection';
const InfiniteScroll = require('react-infinite-scroll-component');

class ItemCardList extends React.Component<IItemCardList, any> {
	public render() {
		const {
			infiniteScrollProps,
			isInfiniteScroll,
			useIntersectionObserver,
			isCarousel,
			carouselSettings,
			addItemCard,
			noResults,
			carouselClassName,
			onScroll,
		} = this.props;

		const itemCards: JSX.Element[] = getCardItems(this.props);

		let infiniteScrollLoader = infiniteScrollProps ? infiniteScrollProps.loader : undefined;
		if (this.props.nextPageItems) {
			const placeholders = getCardPlaceholders(this.props);
			infiniteScrollLoader = <>{placeholders}</>;
		}

		let contentInRow = true;
		let content: any = <>{itemCards}</>;

		const InfiniteScrollComponent = useIntersectionObserver ? InfiniteScrollIntersection : InfiniteScroll;

		if (!this.props.isFetching && this.props.items.length < 1) {
			// if there is add item card -> put it and no results component to row as cards
			if (addItemCard) {
				const rowClass = contentInRow ? 'row no-gutters' : '';
				content = (
					<>
						<div className="wrapperInfinityComponent">
							<InfiniteScrollComponent className={rowClass} {...infiniteScrollProps} loader={infiniteScrollLoader} />
						</div>
					</>
				);
				// otherwise center no results component
			} else {
				if (isCarousel) {
					contentInRow = false;
					content = (
						<Slider
							{...carouselSettings}
							className={carouselClassName && carouselClassName.length > 0 ? carouselClassName : ''}
						>
							{noResults ? noResults : null}
						</Slider>
					);
				}
				if (isInfiniteScroll) {
					content = (
						<div className="wrapperInfinityComponent" onScroll={onScroll}>
							<InfiniteScrollComponent {...infiniteScrollProps} loader={infiniteScrollLoader}>
								{noResults ? noResults : null}
							</InfiniteScrollComponent>
						</div>
					);
				}
			}
		}

		if (isCarousel && itemCards.length > 0) {
			contentInRow = false;
			content = (
				<Slider
					{...carouselSettings}
					className={carouselClassName && carouselClassName.length > 0 ? carouselClassName : ''}
				>
					{itemCards}
				</Slider>
			);
		}

		// Skeletons
		if (isCarousel && this.props.isFetching && !this.props.items.length) {
			contentInRow = false;
			content = (
				<Slider
					{...carouselSettings}
					className={carouselClassName && carouselClassName.length > 0 ? carouselClassName : ''}
				>
					{getCardPlaceholders({ ...this.props, nextPageItems: 1 })}
				</Slider>
			);
		}

		if (isInfiniteScroll && itemCards.length > 0) {
			content = (
				<div className="wrapperInfinityComponent" onScroll={onScroll}>
					<InfiniteScrollComponent {...infiniteScrollProps} loader={infiniteScrollLoader}>
						{content}
					</InfiniteScrollComponent>
				</div>
			);
		}

		// Skeletons
		if (isInfiniteScroll && this.props.isFetching && !this.props.items.length) {
			content = (
				<div className="wrapperInfinityComponent" onScroll={onScroll}>
					<InfiniteScrollComponent {...infiniteScrollProps} loader={infiniteScrollLoader}>
						{getCardPlaceholders({ ...this.props, nextPageItems: 5 })}
					</InfiniteScrollComponent>
				</div>
			);
		}

		return content;
	}
}

export { ItemCardList };
